import React from 'react'
import { View, Text } from '@/components'
import { createStyles } from '@codeleap/styles'
import { MessageSystemProps } from 'stream-chat-react-native'
import { messageSystemText, splitAggregatedSystemMessage } from '@packages/chat/src'
import { textVariant } from '@/config'

export type ChatMessageSystemProps = MessageSystemProps & {}

const SystemMessageBubbleComponent = ({ message }: { message: ChatMessageSystemProps['message'] }) => {
  return (
    <View debugName='chat-message:system' style={styles.wrapper}>
      <Text style={styles.text}>{messageSystemText(message)}</Text>
    </View>
  )
}

const SystemMessageBubble = React.memo(
  SystemMessageBubbleComponent,
  (prevProps, nextProps) => {
    return (
      prevProps.message?.id === nextProps.message?.id
      && messageSystemText(prevProps.message) === messageSystemText(nextProps.message)
    )
  },
)

SystemMessageBubble.displayName = 'SystemMessageBubble'

export const ChatMessageSystem = ({ message }: ChatMessageSystemProps) => {
  const messages = splitAggregatedSystemMessage(message)
  return (
    <>
      {messages.map((item, index) => (
        <SystemMessageBubble
          key={`${item?.id || message?.id || 'system'}-${index}`}
          message={item}
        />
      ))}
    </>
  )
}

const styles = createStyles(theme => ({
  wrapper: {
    borderRadius: theme.radius.large,
    ...theme.spacing.paddingVertical(0.7),
    ...theme.spacing.paddingHorizontal(1),
    ...theme.presets.center,
    alignSelf: 'center',
    width: 'fit-content',
    margin: 'auto',
    ...theme.spacing.marginVertical(1.5),
    backgroundColor: theme.baseColors.neutralSolid300,
  },
  text: {
    ...textVariant(['c2', 'medium']),
    color: theme.colors.textHeadingSubtle,
  },
}))
